import { Button, ModalActions, ModalContent, ModalTitle } from "@kaltura/ds-react-components";
import { useState } from "react";
import CreateTownhallForm, { CreateTownhallFormProps } from "./form/CreateTownhallForm";
import { translate } from "@kaltura/ds-react-utils";

export interface CreateTownhallModalProps extends CreateTownhallFormProps {
    /**
     * is the modal currently open
     */
    open: boolean;

    /**
     * cancel button callback
     */
    onCancel: () => void;
}

const formId = "create-townhall-form";

/**
 * Create Townhall Modal Content component
 */
export const CreateTownhallModalContent = (props: CreateTownhallModalProps) => {
    const { open, onCancel, ...formProps } = props;

    const [processing, setProcessing] = useState(false);
    const [disableButton, setDisableButton] = useState(true);

    const baseClassName = "kms-ds-create-townhall-modal";

    const updateProcessing = (value: boolean) => {
        setProcessing(value);
    };

    const updateDisableButton = (value: boolean) => {
        setDisableButton(value);
    };

    const isButtonDisabled = processing || disableButton;

    return (
        <>
            <ModalTitle className={`${baseClassName}-title`}>{translate("Create town hall")}</ModalTitle>
            <ModalContent className={`${baseClassName}-content`}>
                {open && (
                    <CreateTownhallForm
                        {...formProps}
                        formId={formId}
                        updateProcessing={updateProcessing}
                        updateDisableButton={updateDisableButton}
                    />
                )}
            </ModalContent>
            <ModalActions className={`${baseClassName}-actions`}>
                <Button
                    onClick={onCancel}
                    variant={"borderless"}
                    color={"secondary"}
                    className={`${baseClassName}-actions-cancel`}
                >
                    {translate("Cancel")}
                </Button>
                <Button
                    type={"submit"}
                    loading={processing}
                    disabled={isButtonDisabled}
                    className={`${baseClassName}-actions-submit`}
                    form={formId}
                >
                    {translate("Create")}
                </Button>
            </ModalActions>
        </>
    );
};
